import { render, staticRenderFns } from "./ReceptionnairesList.vue?vue&type=template&id=2450b2f8&scoped=true&"
import script from "./ReceptionnairesList.vue?vue&type=script&lang=js&"
export * from "./ReceptionnairesList.vue?vue&type=script&lang=js&"
import style0 from "./ReceptionnairesList.vue?vue&type=style&index=0&id=2450b2f8&lang=scss&scoped=true&"
import style1 from "./ReceptionnairesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2450b2f8",
  null
  
)

export default component.exports